import {useEffect} from 'react'
import {useMultiActionContext} from '~/components/multi_action/context/multi_action_context'

export const SyncMultiActionStateToTableState = ({data}) => {
	// The checkbox in the table is owned by tanStack and keeps its own state. We want to directly sync the multi action state to the table state.
	const {multiActionActive, multiActionIds} = useMultiActionContext()

	const selectedTableRowIds = data
		.getRowModel()
		.flatRows.filter(row => !row.getIsGrouped() && multiActionIds.includes(row.original.id))
		.map(row => row.id)

	const selectedTableRowKey = [...selectedTableRowIds].sort().join(',')

	useEffect(() => {
		if (!multiActionActive) return data.resetRowSelection()

		const rowSelectionIds = selectedTableRowKey ? selectedTableRowKey.split(',') : []
		data.setRowSelection(rowSelectionIds.reduce((rowSelection, id) => ({...rowSelection, [id]: true}), {}))
	}, [data, multiActionActive, selectedTableRowKey])

	return null
}
